import BaseService from './BaseService';

class UserAccountService extends BaseService {

	constructor() {
		super();
		this.defaultParams = {
			genericFields: [],
			nestedEntities: [
				"billingAccount.customerAccount.customer.seller", 
				"billingAccount.customerAccount.paymentMethods", 
				"billingAccount.billingCycle",
				"name.title", 
				"address.country", 
				"subscriptions.offer.medias",
				"billingAccount.customerAccount.name.title"
			],
			limit: 100,
			offset: 0,
			sortBy: "id",
			sortOrder: "DESCENDING"
		};

	}

	findUserAccount(params) {
		const url = "/api/rest/v2/generic/all/userAccount";
		const payload = {
			...params,
			...this.defaultParams
		}
		return  this.opencellAPI.invokeRequest(payload, url, "POST");
	}

}

const userAccountService = new UserAccountService();

export default userAccountService;



// WEBPACK FOOTER //
// ./src/opencell/services/UserAccountService.js